import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from "react";
export class GridSlotErrorBoundary extends Component {
    state = { hasError: false };
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(error, info) {
        console.warn(`[GridSlotErrorBoundary] Chart ${this.props.chartId} crashed:`, error.message, info.componentStack);
    }
    render() {
        if (this.state.hasError) {
            return (_jsxs("div", { role: "alert", style: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: 200,
                    width: "100%",
                    padding: 16,
                    borderRadius: 8,
                    background: "rgba(185, 28, 28, 0.06)",
                    color: "#991b1b",
                    fontSize: 13,
                    lineHeight: 1.5,
                    textAlign: "center",
                    gap: 8,
                }, "data-chart-id": this.props.chartId, children: [_jsx("span", { style: { fontSize: 24, opacity: 0.7 }, children: "\u26A0" }), _jsx("span", { children: "Chart failed to render" }), _jsx("span", { style: { fontSize: 12, opacity: 0.6 }, children: this.props.chartId })] }));
        }
        return this.props.children;
    }
}
